'use client';
import { jsx } from 'react/jsx-runtime';
import t from 'prop-types';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { RenderComp } from '../core/render-comp.component.js';
import { deprecatedProp } from '../core/deprecated-prop.js';

function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, i = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(o = 0; o < n.length; o++)t = n[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (i[t] = e[t]);
    }
    return i;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, i = {}, n = Object.keys(e);
    for(o = 0; o < n.length; o++)t = n[o], r.indexOf(t) >= 0 || (i[t] = e[t]);
    return i;
}
let p = Object.keys({
    dividers: t.bool,
    gutter: deprecatedProp(t.oneOf([
        'standard',
        'tight'
    ]), 'As it is rarely used, it has been deprecated to improve consistency for customers, and reduce UX debt.')
});
const GridContainer = renderWithRef('GridContainer', null, (r, t)=>{
    var { children: i, dividers: d = false, gutter: a = 'standard' } = r, c = _object_without_properties(r, [
        "children",
        "dividers",
        "gutter"
    ]);
    useComponentStylesLoaded('GridContainer', SWAN_STYLE_KEY_MAP.grid);
    let l = [
        'swan-grid-container'
    ];
    return d && l.push('swan-grid-dividers'), 'tight' === a && l.push('swan-grid-container-tight'), jsx(RenderComp, {
        root: "div",
        forwardedRef: t,
        props: c,
        propKeysToRemove: p,
        classNames: l,
        children: i
    });
});

export { GridContainer };
